import axios from "axios";

const getCEP = (cep) => {
    return axios.get(`https://viacep.com.br/ws/${cep}/json`).then(res => {
        if (!!res && !!res.data) return res.data;
        return null;
    });
}

export default getCEP